<template>
  <div>
    <Header />

    <FlashMessage />

    <div class="py-3">
      <div class="container mx-auto max-w-[1200px] px-6 md:px-0">
        <div class="px-4">
          <!-- Tabs -->
          <div class="flex border-b border-gray-300 mb-4">
            <button
              class="px-4 py-2 focus:outline-none"
              :class="
                tab === 'student'
                  ? 'border-b-2 border-blues text-blues'
                  : 'text-gray-600'
              "
              @click="tab = 'student'"
            >
              Student
            </button>
            <button
              class="px-4 py-2 focus:outline-none"
              :class="
                tab === 'teacher'
                  ? 'border-b-2 border-blues text-blues'
                  : 'text-gray-600'
              "
              @click="tab = 'teacher'"
            >
              Staff
            </button>
          </div>

          <div v-if="tab === 'student'" class="space-y-4">
            <div class="flex flex-col sm:flex-row gap-4">
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  value="single"
                  v-model="uploadType"
                  class="form-radio text-blue-500"
                />
                <span class="text-gray-700">Single Upload</span>
              </label>
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  value="bulk"
                  v-model="uploadType"
                  class="form-radio text-blue-500"
                />
                <span class="text-gray-700">Bulk Upload</span>
              </label>
            </div>

            <div v-if="uploadType === 'single'">
              <SingleUpload />
            </div>

            <div v-if="uploadType === 'bulk'">
              <BulkUpload />
            </div>
          </div>

          <div v-else class="space-y-4">
             <div class="flex flex-col sm:flex-row gap-4">
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  value="single"
                  v-model="uploadTypes"
                  class="form-radio text-blue-500"
                />
                <span class="text-gray-700">Single Upload</span>
              </label>
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  value="bulk"
                  v-model="uploadTypes"
                  class="form-radio text-blue-500"
                />
                <span class="text-gray-700">Bulk Upload</span>
              </label>
            </div>
             <div v-if="uploadTypes === 'single'">
            <StaffUpload />
             
            </div>
            <div v-if="uploadTypes === 'bulk'">
              <StaffBulkUpload />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import axios from "axios";
import { mapGetters } from "vuex";

import FlashMessage from "@/components/FlashMessage.vue";
import SingleUpload from "@/components/Upload/SingleUpload.vue";

import BulkUpload from "@/components/Upload/BulkUpload.vue";
import StaffUpload from "@/components/Upload/StaffUpload.vue";
import StaffBulkUpload from "@/components/Upload/StaffBulkUpload.vue";

export default {
  components: {
    Header,
    FlashMessage,
    SingleUpload,
    BulkUpload,
    StaffUpload,
    StaffBulkUpload,
  },

  data() {
    return {
      tab: "student",
      uploadType: "single",
      uploadTypes: "single",

    };
  },

  computed: mapGetters(["userInfo"]),

  async created() {},
  mounted() {},
  methods: {},
};
</script>

<style></style>
